<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-12">
                <div class="float-sm-end d-flex" style="justify-content: end">
                  <div class="me-2">
                    <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newRule()">
                      <i class="mdi mdi-plus mr-1"></i> Nova Regra
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-hover">
                <thead>
                  <tr>
                    <th width="5%">ID</th>
                    <th width="35%">Nome</th>
                    <th width="20%">Formulário</th>
                    <th width="15%">Tipo Transição</th>
                    <th width="10%">Status</th>
                    <th width="15%">#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="rule in followUpRules" :key="rule.id">
                    <td>{{ rule.id }}</td>
                    <td @click="editRule(rule.id)" class="link">
                      {{ rule.name }}
                    </td>
                    <td>{{ rule.form ? rule.form.name : '-' }}</td>
                    <td>
                      <span class="badge" :class="transitionBadge(rule.transition_type)">
                        {{ transitionLabel(rule.transition_type) }}
                      </span>
                    </td>
                    <td>
                      <b-dropdown
                        size="sm"
                        style="min-width:100px"
                        :variant="rule.is_active ? 'success' : 'danger'"
                      >
                        <template v-slot:button-content>
                          {{ rule.is_active ? 'Ativo' : 'Inativo' }}
                          <i class="mdi mdi-chevron-down"></i>
                        </template>
                        <span>
                          <b-dropdown-item-button @click="toggleStatus(rule.id)" v-if="!rule.is_active">Ativar</b-dropdown-item-button>
                          <b-dropdown-item-button @click="toggleStatus(rule.id)" v-if="rule.is_active">Inativar</b-dropdown-item-button>
                        </span>
                      </b-dropdown>
                    </td>
                    <td>
                      <button type="button" @click="deleteRule(rule)" class="btn btn-outline-danger btn-sm" title="Excluir">
                        <i class="bx bx-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!followUpRules || followUpRules.length === 0">
                    <td colspan="6" class="text-center text-muted py-4">Nenhuma regra cadastrada</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Swal from 'sweetalert2'
import { mapActions, mapState } from 'vuex'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'

export default {
  components: {
    Layout,
    PageHeader
  },
  data () {
    return {
      title: 'Ações de Retorno',
      items: [
        { text: 'Configurações', href: '/' },
        { text: 'Ações de Retorno', active: true }
      ],
      loading: true,
      params: {},
      currentPage: 1,
      perPage: 15
    }
  },
  mounted () {
    this.updateList()
  },
  methods: {
    ...mapActions('followUpRules', {
      getAll: 'getAll',
      delete: 'deleteRule',
      changeStatus: 'changeStatus'
    }),
    newRule () {
      this.$router.push('/settings/follow-up-rules/new')
    },
    editRule (id) {
      this.$router.push(`/settings/follow-up-rules/${id}`)
    },
    transitionLabel (type) {
      const labels = { auto: 'Automático', manual_review: 'Revisão Manual', none: 'Nenhuma' }
      return labels[type] || type
    },
    transitionBadge (type) {
      const badges = { auto: 'bg-success', manual_review: 'bg-warning', none: 'bg-secondary' }
      return badges[type] || 'bg-secondary'
    },
    async toggleStatus (id) {
      try {
        await this.changeStatus(id)
        successMessage('Status atualizado com sucesso.', 2500)
        this.updateList()
      } catch (err) {
        errorMessage('Alerta: ' + err.message)
      }
    },
    async deleteRule (rule) {
      Swal.fire({
        title: 'Você tem certeza?',
        html: `Será excluída a regra: <br /><b>${rule.name}</b>`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.delete(rule.id)
            successMessage('Regra excluída com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            errorMessage('Alerta: ' + (err.response?.data?.message || err.message))
          }
        }
      })
    },
    updateList () {
      let params = {
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      let loader = this.$loading.show()
      this.getAll(this.params).then(() => {
        loader.hide()
      }).catch(error => {
        console.log(error)
        loader.hide()
      })
    }
  },
  computed: {
    ...mapState('followUpRules', ['followUpRules', 'pagination']),
    rows () {
      return this.pagination.total || 0
    }
  }
}
</script>
<style scoped>
.link {
  cursor: pointer;
}
.link:hover {
  color: #556ee6;
}
</style>
